var map = {
	"./bg1.png": 3824,
	"./bg2.png": 7913,
	"./bg3.png": 1425,
	"./bg4.png": 5303,
	"./en.png": 260,
	"./facebook.png": 8900,
	"./go-down.png": 6851,
	"./lang.png": 2234,
	"./th.png": 3167,
	"./zoxa-logo.png": 4336
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;